import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = 'maarivil_access_token';

export function setAuthToken(token) {
  if (token) {
    try { localStorage.setItem(TOKEN_KEY, token); } catch (_e) { /* localStorage unavailable */ }
  } else {
    try { localStorage.removeItem(TOKEN_KEY); } catch (_e) { /* localStorage unavailable */ }
  }
}

export function getAuthToken() {
  try { return localStorage.getItem(TOKEN_KEY); } catch (_e) { return null; }
}

const api = axios.create({
  baseURL: API_BASE,
  // No cookies — JWT travels in the Authorization header instead. This
  // sidesteps iOS Safari ITP / Cloudflare bot-cookie quirks that were
  // intermittently breaking the login POST on iPhone Safari (Feb 2026).
  withCredentials: false,
});

// Attach Bearer token (when present) to every request
api.interceptors.request.use((config) => {
  const tok = getAuthToken();
  if (tok) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${tok}`;
  }
  return config;
});

export default api;

// Normalize FastAPI HTTPException detail (string | {msg} | list) to a string.
// Falls back to a network-specific diagnostic when there's no response (so
// iPhone Safari users see a useful hint instead of the generic message).
export function formatApiErrorDetail(detail, axiosError) {
  if (detail != null) {
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
      return detail.map((d) => (d && d.msg ? d.msg : String(d))).join(' ');
    }
    if (typeof detail === 'object' && detail.msg && typeof detail.msg === 'string') return detail.msg;
    return String(detail);
  }
  // No `detail` in response — probably a network / CORS failure.
  if (axiosError) {
    const status = axiosError.response?.status;
    const code = axiosError.code;
    if (status) return `Server error (HTTP ${status}). Please try again in a moment.`;
    if (code === 'ERR_NETWORK' || axiosError.message === 'Network Error') {
      return 'Could not reach the server. Check your internet connection and try again.';
    }
    if (code === 'ECONNABORTED') return 'Request timed out. Please retry.';
    if (axiosError.message) return `Request failed: ${axiosError.message}`;
  }
  return 'Something went wrong. Please try again.';
}
